import { PortalRequest as request } from "@/utils/request";

// 用户中心活动列表
export const getActivity = (params, data) => {
  return request({
    url: "/activity-enroll/list/me",
    method: "post",
    params: params,
    data,
  });
};

// 课程关联活动的报名验证
export const verificationEnroll = (data) => {
  return request({
    url: "/course-enroll/verification",
    method: "post",
    data,
  });
};

// 用户中心课程列表
export const getCourse = (params, data) => {
  return request({
    url: "/course-enroll/list/me",
    method: "post",
    params: params,
    data,
  });
};

// 前台活动列表
export const getActivityList = (params, data) => {
  return request({
    url: `/activity/list`,
    method: "post",
    params: params,
    data,
  });
};

// 前台课程列表
export const getCourseList = (params, data) => {
  return request({
    url: `/course/list`,
    method: "post",
    params: params,
    data,
  });
};

// 前台活动详情
export const getActivityInfo = (id) => {
  return request({
    url: `/activity/${id}`,
    method: "get",
  });
};

// 前台课程详情
export const getCourseInfo = (id) => {
  return request({
    url: `/course/${id}`,
    method: "get",
  });
};

// 前台活动报名
export const activitySignUp = (id, data) => {
  return request({
    url: `/activity-enroll/${id}/sign-up`,
    method: "post",
    data,
  });
};

// 报名课程-根据课程id
export const courseSignUp = (data) => {
  return request({
    url: `/course-enroll/sign-up`,
    method: "post",
    data,
  });
};

// 活动小程序吗
export const activityQrCode = (id) => {
  return request({
    url: `/activity/${id}/qrCode`,
    method: "get",
  });
};

export const courseChapterTree = (data) => {
  return request({
    url: `/course-chapter/tree-list`,
    method: "get",
    params: data,
  });
};

export const courseStudy = (data) => {
  return request({
    url: `/crs-course-study/save`,
    method: "post",
    data,
  });
};

export const getNotePageList = (params, data) => {
  return request({
    url: `/crs-course-study-note/page-list`,
    method: "post",
    params: params,
    data,
  });
};

export const courseStudyNoteSave = (data) => {
  return request({
    url: `/crs-course-study-note/save`,
    method: "post",
    data,
  });
};

export const studentNoteUploadPublic = (data) => {
  return request({
    url: `/crs-course-study-note/update-is-public`,
    method: "get",
    params: data,
  });
};

export const studentNoteRemove = (id) => {
  return request({
    url: `/crs-course-study-note/remove/${id}`,
    method: "delete",
  });
};

export const getStudyDataStatistics = (data) => {
  return request({
    url: `/crs-course-study/get-study-data-statistics`,
    method: "get",
    params: data,
  });
};

export const getResourceCompleteStatistics = (data) => {
  return request({
    url: `/crs-course-study/get-resource-complete-statistics`,
    method: "get",
    params: data,
  });
};

export const updateStudyCount = (data) => {
  return request({
    url: `/crs-course-study/update-study-count-by-id`,
    method: "get",
    params: data,
  });
};

export const getCourseChapterTree = (data) => {
  return request({
    url: `/course-chapter/tree-list-by-course-study-id`,
    method: "get",
    params: data,
  });
};

export const getStudyCourseContent = (data) => {
  return request({
    url: `/crs-course-study-detail/study-course-content`,
    method: "get",
    params: data,
  });
};
